import { outdent as outdent_1 } from './outdent.locstring.json';
import loc from 'owa-localize';
import RibbonButton from './RibbonButton';
import { callFormatApi } from 'owa-editor/lib/utils/callApi';
import { Indentation } from 'roosterjs-editor-types';

const outdent: RibbonButton = {
    key: 'outdent',
    title: () => loc(outdent_1),
    imageSrc: require('../svg/outdent.svg'),
    imageRtlSrc: require('../svg/outdent-rtl.svg'),
    onExecute: editorViewState =>
        callFormatApi(editorViewState, 'setIndentation', [Indentation.Decrease]),
};

export default outdent;
